import { PollTabSectionStack } from "../PollTab.styles";
import {
    PollSectionTitleTypography,
    PostTextOutlinedInput,
} from "../../PostForm.styles";
import React, { useEffect, useRef } from "react";

export function MainTextSection({
    setPostText,
    postText,
}: {
    postText: string;
    setPostText: (value: string) => void;
}) {
    const pollTextRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        pollTextRef.current?.focus();
    }, []);

    return (
        <PollTabSectionStack>
            <PollSectionTitleTypography>Deine Frage</PollSectionTitleTypography>
            <PostTextOutlinedInput
                ref={pollTextRef}
                autoFocus={true}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        pollTextRef.current?.blur();
                    }
                }}
                value={postText}
                onChange={(event) => {
                    setPostText(event.target.value);
                }}
                placeholder={"Über was möchtest du abstimmen lassen?"}
            />
        </PollTabSectionStack>
    );
}
